const moveUpIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5 10L12 3M12 3L19 10M12 3V21" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>';
const moveDownIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19 14L12 21M12 21L5 14M12 21L12 3" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>';

export const formKitIcons = {
  arrowUp: moveUpIcon,
  arrowDown: moveDownIcon,
};
